import React, { type PropsWithChildren } from 'react';
import { AptosWalletAdapterProvider } from '@aptos-labs/wallet-adapter-react';
import { Network } from '@aptos-labs/ts-sdk';
import { notifySlackError } from 'utils/slack/slackNotifier';

export default function WalletAdapterProvider({ children }: PropsWithChildren) {
	const aptosConnectDappId = process.env.REACT_APP_APTOS_CONNECT_DAPP_ID;

	return (
		<AptosWalletAdapterProvider
			optInWallets={['Petra', 'Continue with Google', 'Continue with Apple']}
			dappConfig={{
				network: Network.MAINNET,
				...(aptosConnectDappId
					? { aptosConnectDappId }
					: {}),
			}}
			autoConnect={true}
			onError={(error) => {
				const errorMessage =
					typeof error === 'string' ? error : error.message;

				// User actions - don't notify
				if (
					errorMessage.includes('User rejected') ||
					errorMessage.includes('user rejected') ||
					errorMessage.includes('rejected the request') ||
					errorMessage.includes('User cancelled') ||
					errorMessage.includes('User denied') ||
					errorMessage.includes('User disapproved')
				) {
					return;
				}

				// Popup blocker errors can occur if the browser blocks auth windows.
				// Ignore only known non-actionable variants.
				if (
					errorMessage.includes("Couldn't open prompt") ||
					errorMessage.includes("couldn't open prompt") ||
					errorMessage.includes('Failed to open')
				) {
					return;
				}

				if (errorMessage.includes('wallet not found')) {
					notifySlackError({
						title: 'Wallet extension not found. Please install Petra wallet.',
						details:
							'Wallet extension not found. Please install Petra wallet.',
					});
					return;
				}

				if (errorMessage.includes('not connected')) {
					notifySlackError({
						title: 'Wallet not connected. Please connect your wallet first.',
						details:
							'Wallet not connected. Please connect your wallet first.',
					});

					return;
				}

				if (errorMessage.includes('network')) {
					notifySlackError({
						title: 'Network error. Please check your connection and try again.',
						details:
							'Network error. Please check your connection and try again.',
					});

					return;
				}

				notifySlackError({
					title: `Wallet error: ${JSON.stringify(error)}`,
					details: ``,
				});
			}}
		>
			{children}
		</AptosWalletAdapterProvider>
	);
}
